import { render, staticRenderFns } from "./ESGAccreditation.vue?vue&type=template&id=3516537c&scoped=true"
import script from "./ESGAccreditation.vue?vue&type=script&lang=js"
export * from "./ESGAccreditation.vue?vue&type=script&lang=js"
import style0 from "./ESGAccreditation.vue?vue&type=style&index=0&id=3516537c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3516537c",
  null
  
)

export default component.exports